import { FaChevronRight } from 'react-icons/fa6';
import { STAGES } from '../../services/autoDub/mockData.js';

const ORDER = ['detected', 'dubbing', 'review', 'publishing', 'published'];

/* Funnel of stage counts across the top of the detail page — each stage tints
   and colours up when it holds items, so the pipeline reads at a glance. */
export default function PipelineStrip({ counts }) {
	return (
		<div className="bg-white rounded-3xl border border-slate-200/80 shadow-[0_10px_40px_-28px_rgba(15,23,42,0.35)] p-2.5 flex items-stretch gap-1 overflow-x-auto">
			{ORDER.map((s, i) => {
				const st = STAGES[s];
				const n = counts[s] || 0;
				const has = n > 0;
				return (
					<div key={s} className="contents">
						<div className="flex-1 min-w-[118px] rounded-2xl px-4 py-3 flex flex-col gap-1.5 transition-colors"
							style={{ background: has ? st.color + '12' : 'transparent' }}>
							<div className="flex items-center gap-2">
								<span className="relative flex h-2.5 w-2.5">
									{has && <span className="absolute inline-flex h-full w-full rounded-full animate-ping opacity-40" style={{ background: st.color }} />}
									<span className="relative inline-flex h-2.5 w-2.5 rounded-full" style={{ background: has ? st.color : '#cbd5e1' }} />
								</span>
								<span className="text-[12.5px] font-semibold" style={{ color: has ? '#475569' : '#94a3b8' }}>{st.label}</span>
							</div>
							<span className="text-[28px] font-bold tabular-nums leading-none" style={{ color: has ? st.color : '#cbd5e1' }}>{n}</span>
						</div>
						{i < ORDER.length - 1 && <div className="self-center text-slate-300 px-0.5"><FaChevronRight size={14} /></div>}
					</div>
				);
			})}
		</div>
	);
}
